import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApiError } from '@/lib/api/errors'
import { cancelReservation } from '@/lib/venue/reservationCancelApi'
import type { ReservationCancelInput, ReservationCancelResultView } from '@/lib/venue/reservationCancelTypes'

import { reservationDetailQueryKey } from './useVenueReservationDetail'

/**
 * 예약 취소 처리 (#672 요구 ②③).
 *
 * 🚨 응답 타입(`ReservationCancelResultView`)이 상세 타입(`ReservationDetailView`)과 **다르다** — 예약
 * 변경(#669)처럼 응답을 상세 쿼리 캐시에 직접 합성하지 않고, 상세 쿼리를 **invalidate**해 서버가 다시
 * 계산한 전체 상세(예약 상태·환불 내역·처리 이력)를 받는다(설계 §2-4 (3) 자율 결정 3).
 */
export function useCancelReservation(venueId: string, reservationId: number) {
  const queryClient = useQueryClient()

  return useMutation<
    ReservationCancelResultView,
    ApiError,
    { input: ReservationCancelInput; idempotencyKey: string }
  >({
    mutationFn: ({ input, idempotencyKey }) => cancelReservation(venueId, reservationId, input, idempotencyKey),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: reservationDetailQueryKey(venueId, reservationId) })
    },
  })
}
